import { Link } from "react-router-dom";

export const LEGAL = { company: "SentinelGuide", email: "support@sentinelguide.app", state: "[Your State]", updated: "June 2026" };

const tabs = [
  { to: "/terms", label: "Terms of Service" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/disclosures", label: "Attorney Directory Disclosures" },
];

export const LegalPage = ({ id, title, intro, sections }) => (
  <main data-testid={`legal-page-${id}`} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 animate-in fade-in duration-500">
    <nav className="flex flex-wrap gap-2 mb-10">
      {tabs.map((t) => (
        <Link key={t.to} to={t.to} data-testid={`legal-tab-${t.to.slice(1)}`}
          className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${t.to === `/${id}` ? "bg-forest-800 text-parchment-50 border-forest-800" : "border-parchment-200 text-ink-600 hover:border-forest-800"}`}>
          {t.label}
        </Link>
      ))}
    </nav>
    <p className="font-mono text-xs uppercase tracking-[0.18em] text-terracotta mb-3">Last updated {LEGAL.updated}</p>
    <h1 data-testid="legal-title" className="font-serif text-4xl sm:text-5xl font-semibold text-forest-900 mb-6">{title}</h1>
    <p className="text-ink-600 leading-relaxed mb-10">{intro}</p>
    <div className="space-y-9">
      {sections.map((s, i) => (
        <section key={s.h} data-testid={`legal-section-${i}`}>
          <h2 className="font-serif text-2xl font-semibold text-forest-900 mb-3">{i + 1}. {s.h}</h2>
          {s.p.map((para) => <p key={para.slice(0, 40)} className="text-sm sm:text-base text-ink-600 leading-relaxed mb-3">{para}</p>)}
        </section>
      ))}
    </div>
    <p className="mt-12 pt-6 border-t border-parchment-200 text-sm text-ink-500">
      Questions? Contact {LEGAL.company} at <a href={`mailto:${LEGAL.email}`} data-testid="legal-contact-email" className="text-terracotta hover:underline">{LEGAL.email}</a>.
    </p>
  </main>
);
